export default __webpack_public_path__ + "static/media/lettermixup_locked_crown.b592de91.svg";